import { MemberPayload } from '../../types/members.types';
import { transport } from '../transport';

import {
  BASE_PATH,
  INVITATIONS_PATH,
  MEMBERS_PATH,
  MEMBERSHIPS_PATH,
} from './config';
import { WixMpResponse } from '../../types/http-responses';
import { InvitationWithOrganization, Organization } from '../../types/entities';

function getMember({ memberId }) {
  return transport.get(`${MEMBERS_PATH}/${memberId}`);
}

function getUserInfo() {
  return transport.get<{ payload: MemberPayload }>(`${MEMBERS_PATH}/me`);
}

function getUserOrganizations({ memberId }) {
  return transport.get<WixMpResponse<Organization[]>>(
    `${MEMBERS_PATH}/${memberId}${BASE_PATH}`,
  );
}

function getUserInvitations({ memberId }) {
  return transport.get<WixMpResponse<InvitationWithOrganization[]>>(
    `${MEMBERS_PATH}/${memberId}${INVITATIONS_PATH}`,
  );
}

function associateMemberWithOrganization({ memberId, organizationId }) {
  return transport.put(
    `${MEMBERS_PATH}/${memberId}${MEMBERSHIPS_PATH}/${organizationId}`,
  );
}

export const membersService = {
  getMember,
  getUserInfo,
  getUserInvitations,
  getUserOrganizations,
  associateMemberWithOrganization,
};
